/**
 * WHERE A SCREEN TAB CAME FROM — history state, carried across every in-place rewrite.
 *
 * Two facts ride here, and both are about the ENTRY rather than the URL, which is why
 * neither is a query param (a shared or typed link must not inherit them):
 *
 *  - `from: "views"` — a Quick setup on Views opened this screen, so the bar offers a
 *    way back to the gallery (Casey 2026-10-09 #2).
 *  - `home` — this screen was entered through the front door (`/`), so what it plays is
 *    what Logo / Menu Home should return to (Casey 2026-10-07 AM #1).
 *
 * React Router drops `location.state` on any navigate that does not restate it, and a
 * screen rewrites its own URL constantly — `?view=` on every Next, the junk-key scrub,
 * the take-it-back `?buy=` scrub, and the replace onto `/view/d/:id` when a signed-in
 * or claimed tab becomes a device. Before this file each of those silently forgot the
 * origin: "Back to views" vanished on the first Next (2026-10-10 review). Every one of
 * them now passes `screenOriginOf(location.state)` back through.
 */
export interface ScreenOrigin {
  from?: "views";
  home?: true;
}

export function screenOriginOf(state: unknown): ScreenOrigin {
  const s = (state ?? null) as { from?: unknown; home?: unknown } | null;
  const origin: ScreenOrigin = {};
  if (s?.from === "views") origin.from = "views";
  if (s?.home === true) origin.home = true;
  return origin;
}
